import React, { FC, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

import { Button } from '@portal/common/components';
import { DataExplorerSelectionResource } from '@portal/common/types';

import _ from '../../../locale';
import {
    getDataToolConfig,
    getSelectedConditionsDataTypes,
} from '../../../store/data-explorer/selectors';
import CopiedPermalinkModal from '../../DataExplorer/SharePermalink/CopiedPermalinkModal';
import SharePermalinkModal from '../../DataExplorer/SharePermalink/SharePermalinkModal';

enum Modals {
    None = 'none',
    SharePermalink = 'share-permalink',
    CopiedPermalink = 'copied-permalink',
}

interface SharePermalinkProps {
    getExplorerSelection: () => DataExplorerSelectionResource;
}

const SharePermalink: FC<SharePermalinkProps> = ({ getExplorerSelection }) => {
    const selectedConditionsDataTypes = useSelector(getSelectedConditionsDataTypes);
    const dataToolConfig = useSelector(getDataToolConfig);

    const [visibleModal, setVisibleModal] = useState(Modals.None);

    const handleSharePermalinkModalOpen = useCallback(() => {
        setVisibleModal(Modals.SharePermalink);
    }, []);

    const handleSharePermalinkModalClose = useCallback((isSubmitted: boolean) => {
        setVisibleModal(isSubmitted ? Modals.CopiedPermalink : Modals.None);
    }, []);

    const handleCopiedPermalinkModalClose = useCallback(() => {
        setVisibleModal(Modals.None);
    }, []);

    return (
        <>
            <Button disabled={!selectedConditionsDataTypes} onClick={handleSharePermalinkModalOpen}>
                {_('data_explorer_share_permalink_btn')}
            </Button>

            {selectedConditionsDataTypes &&
                dataToolConfig &&
                visibleModal === Modals.SharePermalink && (
                    <SharePermalinkModal
                        isVisible
                        onClose={handleSharePermalinkModalClose}
                        dataExplorerSelection={getExplorerSelection()}
                    />
                )}

            <CopiedPermalinkModal
                isVisible={visibleModal === Modals.CopiedPermalink}
                onClose={handleCopiedPermalinkModalClose}
            />
        </>
    );
};

export default SharePermalink;
